"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _root_store = _interopRequireDefault(require("./root_store"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var DashboardStore = /*#__PURE__*/function (_RootStore) {
  function DashboardStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, DashboardStore);
    _this = _callSuper(this, DashboardStore);
    _this.config = {
      GET: {
        users: '/dashboard/users',
        decks: '/dashboard/decks',
        exercises: '/dashboard/exercises',
        levels: '/dashboard/levels',
        payments: '/dashboard/payments',
        subscriptions: '/dashboard/subscriptions',
        didactics: '/dashboard/didactics',
        learnedByLevel: '/dashboard/learned_by_level',
        learningPreferences: '/dashboard/learning_preferences'
      },
      POST: {
        createDidacticCounts: '/dashboard/create_didactic_counts'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(DashboardStore, _RootStore);
  return (0, _createClass2["default"])(DashboardStore, [{
    key: "userAnalytics",
    value: function userAnalytics(params, callback) {
      this.api(params, callback, 'POST', 'userAnalytics');
    }
  }, {
    key: "userAnalyticsReport",
    value: function userAnalyticsReport(params, callback) {
      this.api(params, callback, 'POST', 'userAnalyticsReport');
    }
  }, {
    key: "createDidacticCounts",
    value: function createDidacticCounts(params, callback) {
      this.api(params, callback, 'POST', 'createDidacticCounts');
    }
  }]);
}(_root_store["default"]);
var _default = exports["default"] = new DashboardStore();